import { logger } from '../../../../../../utils/common/logger'
import { DOMUtils } from '../../../../../../utils/dom'
import { IProviderConfig } from '../../../../../common/provider-config'
import { IAd } from '../../../../ad'
import { AdVerifierBase } from '../base'

interface IWindow {
    __iasPET: any
    googletag: any
    dispatchEvent: (event: Event) => void
    iasScores: string
}

declare let window: IWindow

const iasScoreLoadEvent = new Event('ias_score_load_event')
class IntegralAdScience extends AdVerifierBase {
    protected URLPath: string

    constructor() {
        super()
        this.URLPath = '//cdn.adsafeprotected.com/iasPET.1.js'

        if (!document.querySelector(`script[src $= "${this.URLPath}"]`)) {
            DOMUtils.loadScript(this.URLPath)
        }

        // setup object
        window.__iasPET = window.__iasPET || {}
        window.__iasPET.queue = window.__iasPET.queue || []
    }

    public initializeVerifier(conf: IProviderConfig) {
        window.__iasPET.pubId = conf.account
        logger(`debug`, `Initialize IntegralAdScience: ${this.URLPath}`)
    }

    public requestAds(Allads: IAd[], adURI: string, specificAds?: IAd[]) {
        logger('debug', `requestAds:Integral-ad-science: ${specificAds}`)
        this.initIasPetQueue(Allads, adURI, specificAds)
    }

    /**
     * Requests targeting info from IAS service for all page ads.
     */
    private initIasPetQueue(Allads: IAd[], adURI: string, specificAds?: IAd[]) {
        window.__iasPET.queue.push({
            adSlots: (specificAds || Allads).map((ad) => ({
                adSlotId: ad.id,
                adUnitPath: adURI,
                size: ad.sizes
            })),
            dataHandler: (iasScores: string) => {
                window.iasScores = iasScores
                window.dispatchEvent(iasScoreLoadEvent)
                window.__iasPET.setTargetingForGPT()
                if (specificAds) {
                    logger('info', `IAS adapter requestAds with specificAds = ${specificAds.length}`)
                } else {
                    logger('info', `IAS adapter requestAds with specificAds empty`)
                }
            }
        })
    }

}

export default IntegralAdScience
